export default {
  response: state => {
    return state.response;
  }
};
